module.exports = __webpack_public_path__ + "static/media/tj.42512377.svg";